import React from 'react';
import { TFunction } from "react-i18next";
import styles from './ActivitiesCard.module.scss';
import { Language } from "../../../../../../consts/languages"; // Adjusted

interface ActivitiesCardProps {
    combinedActivities: string[];
    t: TFunction;
    language: Language; // Added language prop based on original usage
}

export const ActivitiesCard: React.FC<ActivitiesCardProps> = (props) => {
    const headerText: string = props.t("companyPage.company_info_activities_title");
    const combinedActivities: string[] = props.combinedActivities;

    return (<div className={styles["info-card"]}>
        <h1>{headerText}</h1>
        {combinedActivities.map((activity, index) => <p key={index}>{activity}</p>)}
    </div>)
} 